/*** HOME Made By ES ***/
// @ts-nocheck

import AOS from 'aos';
import 'aos/dist/aos.css';
import { gsap } from 'gsap';
import SplitText from "../components/splitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const page = async () => {

    AOS.init({
        once: true
    });

    splitText();
    

}

//ANIMATION FOR TEXT
const splitText = () =>{
    gsap.registerPlugin(ScrollTrigger);

    new SplitText(".mxmhboxtyc__content--title")
}